import React, {
 useEffect,
} from 'react';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';
import Spinner from 'pages/Dashboard/components/Spinner';
import ActivityEntryLogs from 'pages/Dashboard/pages/Billing/ClaimForm/ClaimActivity/ActivityEntryLogs';
import {
  useGetClaimLogById,
} from 'pages/Dashboard/pages/Billing/hooks';
import {
 billingEventChannel,
} from 'pages/Dashboard/services/eventChannels';

type Props = {
  claimId: number;
};

export default function ClaimActivityLogs({ claimId }: Props) {
  const { data: claimLog, isFetching, refetch } = useGetClaimLogById(claimId);
  const entries = claimLog?.entries ?? [];
  const showSpinner = isFetching && isNil(claimLog);
  const isEmptyAndIdle = isEmpty(entries) && !isFetching;

  useEffect(() => {
    const unsubscribeFromClaimLogChange = billingEventChannel.on('onClaimLogChange', (_claimId) => {
      if (_claimId === claimId) {
        refetch();
      }
    });

    return () => {
      unsubscribeFromClaimLogChange();
    };
  }, [claimId]);

  return isEmptyAndIdle ? null : (
    <>
      {showSpinner && (
        <div className="flex justify-center py-4">
          <Spinner size={24} />
        </div>
      )}
      {!showSpinner && (
        <ActivityEntryLogs entries={entries} />
      )}
    </>
  );
}
